/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

export const en = {
    "error": {
        "403": "You are not authorized to access the page.",
        "title": "Error page!",
        "internalServerError": "Internal server error",
        "server.not.reachable": "Server not reachable",
        "url.not.found": "Not found",
        "NotNull": "Field {{ fieldName }} cannot be empty!",
        "Size": "Field {{ fieldName }} does not meet min/max size requirements!",
        "userexists": "Login name already used!",
        "emailexists": "Email is already in use!",
        "idexists": "A new {{ entityName }} cannot already have an ID"
    }
};
